import { useCurrentTeamMemberContext } from "~/providers/hooks";
import { useInvitationLinks } from "~/providers/hooks/queries/useInvitationLinks";
import { useOrganizationNotifyList } from "~/providers/hooks/useOrganizationNotifyList";
import { useOrganizationProviders } from "~/providers/hooks/useOrganizationProviders";
import { ConsultationRequestLink } from "./ConsultationRequestLink";
import { CreateConsultationLinkModal } from "./CreateConsultationLinkModal";
import { UnassignedConsultationsNotifyList } from "./UnassignedConsultationsNotifyList";

export const ConsultationRequestLinks = () => {
  const teamMember = useCurrentTeamMemberContext();
  const currentOrganizationId =
    teamMember.organization_team_members[0].organization_id;
  const { data: links } = useInvitationLinks();
  const { data: providers } = useOrganizationProviders(currentOrganizationId);
  const { data: notifyList } = useOrganizationNotifyList(currentOrganizationId);

  if (!links || !providers || !notifyList) return null;

  const isDeleteEnabled = links.length > 1;

  return (
    <div className="w-full md:max-w-[49rem]">
      <div className="flex flex-col gap-4">
        <div className="flex flex-col justify-between gap-6 sm:flex-row">
          <p className="max-w-96 text-sm sm:text-base">
            Consultation request links allow prospective patients to initiate a
            consultation.
          </p>
          <CreateConsultationLinkModal providers={providers} />
        </div>
        <UnassignedConsultationsNotifyList
          notifyList={notifyList}
          availableProviders={providers}
        />

        {links.map((link) => (
          <ConsultationRequestLink
            key={link.id}
            link={link}
            isDeleteEnabled={isDeleteEnabled}
            providers={providers}
          />
        ))}
      </div>
    </div>
  );
};
